export const TEST_ID = 'onboardingTopBar';
